import { FC } from "react";
import styles from "./TableHead.module.sass";

export const TableHead: FC = () => {
	const criteriaList = ["Социальная", "Политическая", "Экономическая", "Экологическая", "Оборонная"];

	return (
		<thead className={styles.head}>
			<tr className={styles.row}>
				<th colSpan={3} className={styles["item-parent"]}>
					Описательная часть реестра бизнес-процессов организации
				</th>
				<th colSpan={7} className={styles["item-parent"]}>
					Оценка критичности бизнес-процессов
				</th>
				<td rowSpan={3} className={styles["item-independent"]}>
					Порядковый номер процесса
				</td>
				<td rowSpan={3} className={styles["item-independent"]}>
					Связанные объекты
				</td>
			</tr>
			<tr className={styles.row}>
				<th rowSpan={2} className={styles["item-child"]}>
					Класс бизнес-процессов
				</th>
				<th rowSpan={2} className={styles["item-child"]}>
					Бизнес-процессы в деятельности организации
				</th>
				<th rowSpan={2} className={styles["item-child"]}>
					Краткое описание бизнес-процессов в деятельности организации
				</th>

				<th colSpan={5} className={styles["item-child"]}>
					Критерии значимости
				</th>
				<th rowSpan={2} className={styles["item-child"]}>
					Описание возможных последствий
				</th>
				<th rowSpan={2} className={styles["item-child"]}>
					Заключение о критичности
				</th>
			</tr>
			<tr className={styles.row}>
				{criteriaList.map((item, i) => (
					<th key={i} className={styles["row-third"]}>
						<div>
							{item.split("").map((letter, i) => (
								<span key={i}>{letter}</span>
							))}
						</div>
					</th>
				))}
			</tr>
		</thead>
	);
};
